import React, {Component} from 'react';
import {AppContext} from './AppContext';
import {Route, Switch, Redirect} from 'react-router-dom';
import Sidebar from './components/sidebar/Sidebar';
import Header from './components/header/Header';
import {Grid} from 'react-bootstrap';
import EvidenceTypeChooser from './components/EvidenceTypeChooser';
import EvidencePostSubmit from './components/EvidencePostSubmit';
import EvidenceSubmitter from './components/EvidenceSubmitter';
import appRoutes from './routes.js';
import {ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ScrollToTop from "./components/ScrollToTop";
import { injectIntl } from "react-intl";
import { customerConfig } from './config';
import { startSession } from "./components/UsageAnalytics";
import VerificationRequired from "./components/VerificationRequired";

class App extends Component {

  constructor(props) {
    super(props);

    // make `this` accessible in method
    this.toggleSidebar = this.toggleSidebar.bind(this);
    this.openSidebar = this.openSidebar.bind(this);
    this.closeSidebar = this.closeSidebar.bind(this);

    // state serves as {AppContext} value as well
    // methods here *implement* functionality of ones in {AppContext}
    this.state = {
      width: window.innerWidth,
      isSidebarOpen: true,
      toggleSidebar: this.toggleSidebar,
      openSidebar: this.openSidebar,
      closeSidebar: this.closeSidebar,
      sidebarBreakpoint: 993
    };

    // start user session;
    const packageName = customerConfig.packageName;
    startSession(packageName);

    console.log('Customer:', process.env.REACT_APP_CUSTOMER, 'environment:', process.env.NODE_ENV, 'API:', process.env.REACT_APP_SCANSTATION_SERVER, 'Usage:', process.env.REACT_APP_SCANSTATION_USAGE_SERVER);
  }

  componentDidMount() {
    this.updateDimensions();
    window.addEventListener("resize", this.updateDimensions.bind(this));
    this.refreshSidebarState();
  }

  /**
   * Close sidebar after location changes
   */
  componentDidUpdate(e) {
    if (e.history.location.pathname !== e.location.pathname) {
      this.refreshSidebarState()
    }
  }

  toggleSidebar() {
    this.setState(state => {
      return {
        isSidebarOpen: !state.isSidebarOpen
      }
    });
  }

  openSidebar() {
    this.setState({
      isSidebarOpen: true
    });
  }

  closeSidebar() {
    this.setState({
      isSidebarOpen: false
    });
  }

  updateDimensions() {
    const width = window.innerWidth;
    if (this.state.width !== width) {
      this.setState({width: width});
      this.refreshSidebarState()
    }
  }

  refreshSidebarState() {
    if (this.state.width < this.state.sidebarBreakpoint) {
      this.state.closeSidebar()
    } else {
      this.state.openSidebar()
    }
  }

  render() {
    let routeIndex = 0;

    // routes that can be directly navigated to
    let rootRoutes = appRoutes.map(prop => {
      return (
        <Route path={prop.path} component={prop.component} key={`route${routeIndex++}`}/>
      );
    });

    return (

      <AppContext.Provider value={this.state}>

        <div className={'wrapper ' + (this.state.isSidebarOpen ? 'nav-open' : '')}>
          <Sidebar {...this.props} />
          <div id="main-panel" className="main-panel">
            <Header/>
            <ToastContainer/>
            <div className="content">
              <Grid fluid>
                <Switch>
                  {rootRoutes}

                  {/* nested routes that cannot be directly navigated to directly (except by pasting the URL into the address bar) */}
                  <Route path='/:serviceAreaId' exact={true} component={EvidenceTypeChooser}/>
                  <Route path='/:serviceAreaId/:evidenceTypeId' exact={true} component={EvidenceSubmitter}/>
                  <Route path='/:serviceAreaId/:evidenceTypeId/success' component={EvidencePostSubmit}/>
                  <Route path='/:serviceAreaId/:evidenceTypeId/verification-required' exact={true} component={VerificationRequired}/>

                  {/* route for redirecting to the default component */}
                  <Redirect from="/" to="/home"/>

                </Switch>
              </Grid>
            </div>
          </div>
          <ScrollToTop/>
        </div>

      </AppContext.Provider>
    );
  }
}

export default injectIntl(App);
